// src/LoopIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var LoopIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M16.75 9C17.1642 9 17.5 9.33579 17.5 9.75C17.5 14.0282 14.0282 17.5 9.75 17.5C7.55754 17.5 5.82916 16.3966 4.68555 15.3594C4.54097 15.2282 4.4052 15.0967 4.27734 14.9678V16.3584C4.27713 16.7723 3.94127 17.1082 3.52734 17.1084C3.11326 17.1084 2.77756 16.7724 2.77734 16.3584V12.8584C2.77734 12.4442 3.11313 12.1084 3.52734 12.1084H6.69141C7.10543 12.1086 7.44141 12.4443 7.44141 12.8584C7.44119 13.2723 7.1053 13.6082 6.69141 13.6084H5.05371C5.2402 13.8134 5.45397 14.0309 5.69336 14.248C6.69525 15.1568 8.07846 16 9.75 16C13.1998 16 16 13.1998 16 9.75C16 9.33579 16.3358 9 16.75 9Z" }),
      /* @__PURE__ */ jsx("path", { d: "M9.75 2C12.3072 2 14.2215 3.06904 15.4814 4.12012C15.6687 4.27636 15.8406 4.43412 16 4.58691V3.1416C16.0002 2.72757 16.3359 2.3916 16.75 2.3916C17.1641 2.3916 17.4998 2.72757 17.5 3.1416V6.6416C17.5 7.05582 17.1642 7.3916 16.75 7.3916H13.6416C13.2276 7.39139 12.8916 7.05568 12.8916 6.6416C12.8918 6.2277 13.2277 5.89182 13.6416 5.8916H15.1865C14.9939 5.69313 14.7724 5.48164 14.5205 5.27148C13.4477 4.37661 11.8617 3.5 9.75 3.5C6.27417 3.5 3.5 6.29826 3.5 9.75C3.5 10.1642 3.16421 10.5 2.75 10.5C2.33579 10.5 2 10.1642 2 9.75C2 5.47374 5.44183 2 9.75 2Z" })
    ]
  }
);

export {
  LoopIcon
};
